export default function()
{
    const self = this;

    /**
     * Replace placeholders in an image URL
     * @param {String|null} placeholderUrl
     * @param {String}      size
     * @param {String}      extension
     * @return {String|null} The definitive image URL, or null in case the original URL is empty
     */
    self.makeImageUrl = (placeholderUrl = null, size = '', extension = 'jpg') => {
        if (! placeholderUrl) {
            return null;
        }

        let width, height;

        switch (size) {
            case 'card':
                width = 225;
                height = 225;
                break;

            case 'card-mobile':
                width = 225;
                height = 225;
                break;

            case 'header-mobile':
                width = 500;
                height = 300;
                break;

            case 'still':
                width = 900;
                height = 600;
                break;

            case 'still-mobile':
                width = 600;
                height = 400;
                break;

            case 'still-thumbnail':
                width = 150;
                height = 150;
                break;

            default:
                width = 1500;
                height = 1000;
                break;
        }

        // Only .jpg and .png are supported
        extension = extension.replace('.', '');
        if (extension !== 'jpg' && extension !== 'png') {
            return null;
        }

        return placeholderUrl
            .replace('{maxWidth}', width)
            .replace('{maxHeight}', height)
            .replace('(jpg|png)', extension);
    };

    /**
     * Replace placeholders in a video URL
     * @param {String|null} placeholderUrl
     * @param {String}      size
     * @param {String}      extension
     * @return {String|null} The definitive video URL, or null in case the original URL is empty
     */
    self.makeVideoUrl = (placeholderUrl = null, size = '', extension = 'mp4') => {
        if (! placeholderUrl) {
            return null;
        }

        let width, height;

        switch (size) {
            case 'mobile':
                width = 640;
                height = 360;
                break;

            default:
                width = 1280;
                height = 720;
                break;
        }

        // Only .jpg and .png are supported
        extension = extension.replace('.', '');
        if (extension !== 'mp4' && extension !== 'mov') {
            return null;
        }

        return placeholderUrl
            .replace('{maxWidth}', width)
            .replace('{maxHeight}', height)
            .replace('(mp4|mov)', extension);
    };
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/MediaHelper.js